import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    if (typeof window !== 'undefined') window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
          <div className="max-w-lg w-full bg-white rounded-3xl border border-slate-200 shadow-xl p-8 text-center">
            <h1 className="text-xl font-black text-rose-600 tracking-tight">Something went wrong</h1>
            <p className="text-sm font-bold text-slate-500 mt-2">
              The page hit an unexpected error. Check the browser console for details.
            </p>
            {this.state.error?.message && (
              <pre className="mt-4 text-left text-[11px] font-mono bg-slate-900 text-rose-200 rounded-xl p-4 overflow-auto max-h-48">
                {this.state.error.message}
              </pre>
            )}
            <button
              onClick={this.handleReload}
              className="mt-6 px-6 py-3 bg-[#143E78] text-white rounded-2xl text-sm font-black uppercase tracking-wider hover:bg-[#0f2f5e] transition-all"
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
